<template>
  <div
    v-if="!haveSignature"
    class="container-fluid d-block d-lg-none position-fixed mt-6"
    :class="[
      isToolBarMobileOpen ? 'py-3' : 'py-2 border-top',
      isMenuOpen ? 'bg-white' : 'bg-gray-400'
    ]"
    style="bottom:0px; z-index:30; box-shadow: rgba(0, 0, 0, 0.2) 0px 5px 25px;
    border-top-left-radius: 20px; border-top-right-radius: 20px;"
  >
    <div
      class="position-absolute"
      style="right:0;left:0;"
      :style="{ bottom: `${isToolBarMobileOpen ? 45 : 0}px` }"
    >
      <div class="w-100 d-flex justify-content-center">
        <div
          class="d-flex rounded-circle"
          :class="isMenuOpen ? 'bg-white' : 'bg-gray-400'"
          style="box-shadow: 0px -5px 7px 2px rgba(0,0,0,0.04); width: 40px; height:40px"
          @click="showMenu"
        >
          <v-icon
            :icon="isToolBarMobileOpen ? 'chevron-down' : 'chevron-up'"
            class="m-auto"
          />
        </div>
      </div>
    </div>
    <div
      v-show="isToolBarMobileOpen"
      class="container lead bg-light"
      style="transition:all 1s"
    >
      <div class="row">
        <div class="col-12 d-flex flex-row justify-content-between">
          <router-link
            v-for="link in links"
            :key="link.path"
            v-slot="{ navigate }"
            :to="`/client/${link.path}`"
            custom
          >
            <v-icon
              :icon="$route.path !== `/client/${link.path}`
                ? link.icon
                : link.icon + '-blue-500'"
              width="20"
              height="20"
              @click="navigate"
            />
          </router-link>
          <div
            class="d-flex my-auto cursor-pointer"
            style="width:25px"
          >
            <v-icon
              :icon="!menuMobile ? 'ellipsis' : 'ellipsis-blue-500'"
              width="20"
              height="20"
              @click="showMobileMenu"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  beforeRouteUpdate(to, from, next) {
    if (this.$store.getters['ui/menuMobile']) {
      this.$store.dispatch('ui/setValue', { menuMobile: false });
    }
    next();
  },
  data() {
    return {
      links: [
        { path: 'contracts', icon: 'contract' },
        { path: 'invoices', icon: 'bills' },
        { path: 'home', icon: 'home' },
        { path: 'certificates', icon: 'certificate' },
      ],
    };
  },
  computed: {
    ...mapGetters({
      menuMobile: 'ui/menuMobile',
      isMenuOpen: 'ui/isMenuOpen',
      isToolBarMobileOpen: 'ui/isToolBarMobileOpen',
    }),
    signatures() { return this.$store.state.company.signatures; },
    haveSignature() {
      if (this.signatures && this.signatures.length > 0) {
        return this.signatures.some((signature) => signature.status === 'WAITING');
      } return false;
    },
    binds() {
      return ({
        tag: 'div',
        class: 'd-flex my-auto',
        'active-class': 'text-primary',
        style: 'width:25px',
      });
    },
  },
  methods: {
    showMenu() {
      if (this.isMenuOpen) {
        this.$store.dispatch('ui/setValue', { isToolBarMobileOpen: !this.isToolBarMobileOpen });
      }
    },
    showMobileMenu() {
      this.$store.dispatch('ui/setValue', { menuMobile: !this.menuMobile });
    },
  },
};

</script>
